export default async (endpoint, file, onProgress) =>
  new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();

    request.open('PUT', endpoint, true);

    request.onreadystatechange = () => {
      if (request.readyState !== XMLHttpRequest.DONE) {
        return;
      }

      if (request.status <= 299) {
        resolve(request.status);
      } else {
        reject();
      }
    };

    request.onabort = () => {
      reject(new Error('Request is aborted'));
    };

    request.onerror = () => {
      reject(new Error('Network Error'));
    };

    request.ontimeout = () => {
      reject(new Error('Timeout Error'));
    };

    // Set headers
    request.setRequestHeader('x-amz-acl', 'bucket-owner-full-control');
    request.setRequestHeader('Content-Type', 'application/octet-stream');
    // eslint-disable-next-line no-restricted-globals
    if (location.hostname !== 'localhost') {
      request.setRequestHeader('x-amz-server-side-encryption', 'aws:kms');
      request.setRequestHeader(
        'x-amz-server-side-encryption-aws-kms-key-id',
        'arn:aws:kms:us-west-2:558766445240:alias/aws/s3'
      );
    }

    if (onProgress) {
      request.upload.addEventListener('progress', (event) => {
        const ratio = Math.ceil((event.loaded / event.total) * 100);
        onProgress(ratio);
      });
    }

    request.send(file);
  });
